import React from "react";

function SmallSpinner() {
  return (
    <div className="w-8 h-8  border-4 border-dashed rounded-full animate-spin dark:border-green-400"></div>
  );
}

export default SmallSpinner;
